import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import LoginForm from "../forms/loginform/LoginForm";
import "./loginmobile.scss";

const LoginMobile = (props) => {
  return (
    <Fragment>
      <div className="login-container-mobile mx-auto">
        <div className="row g-0 login-form-row flex-column justify-content-between align-items-center mx-auto">
          <div className="selling-col order-3">
            <div className="selling-information-container">
              <div className="header-text">
                Selling with Alisouq is now really easy!
              </div>
              <div className="gray-header mx-auto">
                List your products and start your business with Alisouq
              </div>
              <div className="paragraph-text mx-auto">
                Start selling absolutely free. All you need is to register, list
                your catalogue and start selling your products.
              </div>
              <Link to="/create-store">
                <div className="button mx-auto">
                  <button type="button">Start Selling</button>
                </div>
              </Link>
            </div>
          </div>
          <div className="line-col order-2"></div>
          <div className="login-form-col order-1 d-flex flex-column align-items-center">
            <div className="logo-container">
              <img src={Logo} alt="" width="100%" height="auto" />
            </div>
            <div className="login-header mx-auto">Sign in to Your account</div>
            <div className="login-form">
              <div className="form-inputs mx-auto">
                <LoginForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default LoginMobile;
